<div class="virtual-scroll-data-source" *ngIf="table">
    <cdk-virtual-scroll-viewport orientation="horizontal" itemSize="5" class="viewport">
        <!-- first column for fields displaying -->
        <div class="fields-header">
            <!-- empty cell in 1st row and 1st column -->
            <div class="cell header">
                <div *ngIf="showRequiredFieldsSwitch" class="required-fields-only-switch-container">
                    <mat-slide-toggle [(ngModel)]="viewSettingsService.showOnlyRequiredFields">Required Fields
                        Only</mat-slide-toggle>
                </div>
            </div>
            <div *ngFor="let section of sections">
                <div *ngIf="hasVisibleFields(section)">
                    <div *ngIf="table.settings.hasSections" class="cell section">{{section.label}}</div>
                    <div *ngFor="let field of getSectionFields(section)">
                        <ziq-header-field [fieldSettings]="field" [currentTab]="currentTab"
                            [tableType]="table.calibrationType" [table]="table">
                        </ziq-header-field>
                    </div>
                </div>
            </div>
        </div>

        <div *cdkVirtualFor="let modelData of columns; index as i" class="item">
            <div class="cell section header">
                <div class="icons-container">
                    <cut-down-content length="12">{{modelData.calibrationSet.Name}}</cut-down-content>
                    <calibration-set-attributes [identifiers]="modelData.calibrationSet.identifier"
                        [attributePopupTitleDetails]="modelData.calibrationSet.Name">
                    </calibration-set-attributes>
                </div>
                <div class="icons-container to-right">
                    <ziq-calibration-set-attributes-icons [attributesFlags]="modelData.calibrationSet">
                    </ziq-calibration-set-attributes-icons>
                </div>
            </div>
            <div *ngFor="let section of sections;trackBy: getSectionIdentifier;">
                <!-- empty cell for section separator if table has sections -->
                <div *ngIf="hasVisibleFields(section)">
                    <div *ngIf="table.settings.hasSections" class="cell"></div>
                    <div class="cell"
                        *ngFor="let field of getSectionFields(section); trackBy: getCellIdentifier.bind(this, i)">
                        <ziq-number-value-field *ngIf="field.type == fieldType.NUMBER" [currentTab]="currentTab"
                            [model]="modelData" [fieldSettings]="field"
                            [attributePopupTitleDetails]="modelData.calibrationSet.Name + ' - ' + field.label"></ziq-number-value-field>
                        <ziq-boolean-value-field *ngIf="field.type == fieldType.BOOLEAN" [currentTab]="currentTab"
                            [model]="modelData" [fieldSettings]="field"
                            [attributePopupTitleDetails]="modelData.calibrationSet.Name + ' - ' + field.label"></ziq-boolean-value-field>
                        <ziq-number-na-value-field *ngIf="field.type == fieldType.NUMBER_NA" [currentTab]="currentTab"
                            [model]="modelData" [fieldSettings]="field" [table]="table"
                            [attributePopupTitleDetails]="modelData.calibrationSet.Name + ' - ' + field.label"></ziq-number-na-value-field>
                    </div>
                </div>
            </div>
        </div>
    </cdk-virtual-scroll-viewport>
</div>
